import * as axios from "axios"
import { useEffect, useState } from "react"
import { getPaywallSettingsFromLocalStorage } from "./authOperations"
import { getPaywallAccessData, getPaywallReadAllowed } from "./paywallApiUrls"
import { CustomerAccessData } from "./paywallInterfaces"

export type ArticleClaims = {
  free: string
  premium: string
}

export const useArticleRestriction = (articleClaims: ArticleClaims, resourceId: string): boolean => {

  const [showPaywall, setShowPaywall] = useState(false)

  const checkPaywallReadAllowed = async (url: string) => {
    try {
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error('Error checking paywall read allowed:', error);
      setShowPaywall(true);
    }
  };

  useEffect(() => {
    (async () => {
      const userDetails = getPaywallSettingsFromLocalStorage()

      if (!userDetails) {
        setShowPaywall(true);
        return
      }


      const response = await axios.get<{ data: CustomerAccessData }>(getPaywallAccessData());
      const accessData = response && response.data && response.data.data as CustomerAccessData;

      if (accessData) {
        const isPremium = accessData.claims.includes(articleClaims.premium)
        const isFree = accessData.claims.includes(articleClaims.free)
        if (isPremium) {
          return;
        }
        if (isFree) {
          const isAllowedToRead = await checkPaywallReadAllowed(getPaywallReadAllowed(articleClaims.free, resourceId));
          if (!isAllowedToRead) {
            setShowPaywall(true);
          }
        } else {
          setShowPaywall(true);
        }
      }
    })()
  }, [articleClaims.free, resourceId])

  return showPaywall
}